/** @jsxImportSource @emotion/react */
import {useEffect, useState} from 'react'
import Tools from "script/sweet-tools.mjs";
import './print.css'
import moment from "moment";
import {round} from "lodash";

/**
 * 业务审批详情入口页（嵌入到审批弹窗中使用）
 * @param flowInstance 审批实例对象
 * @param params 入参，提交给 FlowAuditModal 组件的入参都会原样透传过来
 * @param visible 当前弹窗是否打开，布尔型
 * @constructor
 */
const PURPRODPCPane = ({pcId}) => {

    // 合同
    const [purPc, setPurPc] = useState({});
    const [pcSum, setPcSum] = useState({});
    // 合同明细
    const [data, setData] = useState([]);
    // 合同二维码
    const [pcQrCode, setPcQrCode] = useState(null);
    // 合同签章
    const [signList, setSignList] = useState([]);
    //const defaultImg = "data:image/png;base64,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";
    //const qrImg="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAIAAACzY+a1AAACWUlEQVR42u3aQW7DMAwEwPz/0+0X%0D%0AYpBLSvHssWhii2MgFK3Pn1yejxIgFISCEKEgFISCEKEgFISCEKEgFISCEOGTzwTy9FqVe3u6xhPq%0D%0AgBAhQoQIzyUs/Q4HSNKP0VYdECJEiBDhHYSVcldoJ8s9WQeECBEiRIhwYiyQ2P4jRIgQIUKEKcLK%0D%0AsrtGBAgRIkSIEOHEeHdr237adREiRIgQ4R2EiWM/N/7dCTaECBEifBdhOpVXvie3S6lyIUSIECHC%0D%0AecLJY7iV8XFi5D25XoQIESJE+PuE33y20sIkjjYl2p/L3tojRIgQIcLQrVeWsThibnmsD21nECJE%0D%0AiBBhY+m7WoPE6+KudmxxLI4QIUKECBcIt0bAXWPoLtrJ0TxChAgRIryPsFLKdLtUIU/c8/JRYIQI%0D%0AESJEuEjYtT3vGpFP8l+wtUeIECFChMVlT35n+lHoGguEaogQIUKECJcJJ48Fp48tpUlCa0GIECFC%0D%0AhBcQJrbY6TJ1jSAGjkshRIgQIcJlwq2WZ7Jl6BrTXzadQYgQIUKEobFyekR+2j0MvP5FiBAhQoQX%0D%0AtDPp7fPk9rxrfI8QIUKECO8mTCddggrbge0VQoQIESI86JVv189+Yvuc+P/htgUhQoQIEV42I023%0D%0AFYmW4bSjXAgRIkSI8O6zM5Mj5q1WaLKVQ4gQIUKECDtHzFvb+RAnQoQIESJ8EeHkaLurDrb2CBEi%0D%0ARPguwsnvmXytmrgWQoQIESL8HcLEqPeE1qMydhgYbSNEiBAhwmVCOSoIEQpCQYhQEApCQYhQEApC%0D%0AQYhQEApCQfje/ANW2G2tuQDM7gAAAABJRU5ErkJggg==";

    useEffect(() => {
        (async () => {
            if (pcId) {
                init()
            }
        })()
    }, [pcId])


    //查询合同明细、分批明细
    const init = async () => {
        try {
            if (pcId) {
                doQueryPurPc();
                doQueryQrCode();
                doQuerySign();
                await Promise.all([doQueryDtl(), doQueryPP()]).then((data) => {
                    // 组装商品明细行
                    let rowsNew = data[0];
                    let ppRowsNew = data?.length > 1 ? data[1] : [];

                    // 合计
                    let purTxAmt = 0.00;
                    let purQty = 0;
                    rowsNew.forEach(row => {
                        const filterPpRows = ppRowsNew.filter(ppRow => ppRow.purPcProdRowId == row.purPcProdRowId);
                        row.purPcPpRowDRs = filterPpRows;
                        if (filterPpRows && filterPpRows.length > 0) {
                            // 汇总数据
                            let keyTxDyDateSet = new Set(); // 合并行实际交货日期:相同保留
                            let keyMatDyDateSet = new Set(); // 合并行面辅料到厂日期:相同保留
                            for (let nowIndex = 0; nowIndex < filterPpRows.length; nowIndex++) {
                                if (filterPpRows[nowIndex].txDyDate)
                                    keyTxDyDateSet.add(moment(filterPpRows[nowIndex].txDyDate).format('YYYY-MM-DD'));
                                if (filterPpRows[nowIndex].matDyDate)
                                    keyMatDyDateSet.add(moment(filterPpRows[nowIndex].matDyDate).format('YYYY-MM-DD'));
                            }
                            row.txDyDates = keyTxDyDateSet.size > 0 ? Array.from(keyTxDyDateSet.keys()).join(',') : null;// 实际交货日期
                            row.matDyDates = keyMatDyDateSet.size > 0 ? Array.from(keyMatDyDateSet.keys()).join(',') : null; // 面辅料到厂日期
                        }

						// 单价小于2位补0，多的有几位保留几位、金额保留两位
                        row.purTxPrice = numberFormat(row.purTxPrice);
                        row.purTxAmt = row.purTxAmt?.toFixed(2);
                        // 合计
                        purQty += row.purQty ? Number(row.purQty) : 0;
                        purTxAmt += row.purTxAmt ? Number(row.purTxAmt): 0;
                    })
                    setData(rowsNew)

                    setPcSum({
                        purQty: round(purQty,3),
                        purTxAmt: purTxAmt?.toFixed(2)
                    })
                })
            }

        } finally {

        }
    }
    
    const numberFormat = (num, toFixedNum=8, minFractionNum=2) => {
		let fraction = String(Number(num)).split(".")[1];
		
		if (!fraction) {
			return Number(num).toFixed(minFractionNum);
		}
		let fractionNum = fraction.length;
	
		if (fractionNum < minFractionNum) {
			return Number(num).toFixed(minFractionNum);
		} else if (fractionNum > toFixedNum) {
			return Number(num).toFixed(toFixedNum);
		} else {
			return String(Number(num));
		}
	}

    // 查询合同信息
    const doQueryPurPc = async () => {
        try {
            let purPcDR = await Tools.runAsync(
                async () => {
                    return await Tools.http.post("/pur/procpurpc/onePurPcDR", {pcId})
                },
                {
                    error: {content: (err) => `查询生产采购合同失败: ${err.message}`},
                    loading: {show: false},
                    success: {show: false},
                }
            );
            if (purPcDR) {
                // 取出公司帐套
                const coAcct = await Tools.runAsync(
                    async () => {
                        return await Tools.http.post("/bas/basCoAcct/oneBasCoAcct", {coAcctId: purPcDR.pcCoAcctId})
                    },
                    {
                        error: {content: (err) => `查询公司帐套失败: ${err.message}`},
                        loading: {show: false},
                        success: {show: false},
                    }
                );
                purPcDR.coNameEn = coAcct.coNameEn;
                purPcDR.coBizAddrEn = coAcct.coBizAddrEn;
                purPcDR.coRegPhone = coAcct.coRegPhone;
                purPcDR.coBankNameEn = coAcct.coBankNameEn;
                purPcDR.coBankAn = coAcct.coBankAn;
                purPcDR.coUscc = coAcct.coUscc;
                purPcDR.coRegAddr = coAcct.coRegAddr;

                // 取出供应商信息
                const supp = await Tools.runAsync(
                    async () => {
                        return await Tools.http.post("/pnr/pnr/onePnr", {pnrId:purPcDR.pcSuppId})
                    },
                    {
                        error: {content: (err) => `查询供应商失败: ${err.message}`},
                        loading: {show: false},
                        success: {show: false},
                    }
                );
                purPcDR.suppCoRegAddr = supp.coRegAddr
                purPcDR.suppPnrPhone = supp.pnrPhone
                purPcDR.suppCoUscc = supp.coUscc

                setPurPc(purPcDR);
            }
        } finally {
        }
    }

    // 查询合同二维码
    const doQueryQrCode = async () => {
        try {
            let pcQrCodeData = await Tools.runAsync(
                async () => {
                    return await Tools.http.post("/pur/procpurpc/pcQrCode", {pcId})
                },
                {
                    error: {content: (err) => `查询合同二维码失败: ${err.message}`},
                    loading: {show: false},
                    success: {show: false},
                }
            );
            if (pcQrCodeData) {
                console.log("pcQrCodeData", pcQrCodeData)
                setPcQrCode(pcQrCodeData);
            }
        } finally {
        }
    }

    // 查询合同签章
    const doQuerySign = async () => {
        try {
            let signList = await Tools.runAsync(
                async () => {
                    return await Tools.http.post("/pur/procpurpc/listPcSign", {pcId})
                },
                {
                    error: {content: (err) => `查询合同签章失败: ${err.message}`},
                    loading: {show: false},
                    success: {show: false},
                }
            );
            if (signList) {
                //let signBlobList = signList.map(r => {
                //    let blob = new Blob([r.empSign], {type: "img/png"});
                //    let objectUrl = URL.createObjectURL(blob);
                //    return {
                //        src: objectUrl
                //    }
                //})
                console.log("signList=", signList)
                setSignList(signList);
            }
        } finally {
        }
    }

    //查询合同明细
    const doQueryDtl = async () => {
        try {
            // 查询合同明细
            let param = {pcId: pcId}
            const data = await Tools.runAsync(
                async () => {
                    return await Tools.http.post("/pur/purpcprodrow/listPurPcProdRowDRs", param)
                },
                {
                    error: {content: (err) => `查询失败: ${err.message}`},
                    loading: {show: false},
                    success: {show: false},
                }
            )
            if (data != null && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    data[i].price = (( data[i].purTxPrice??0 ) / (1 + (( data[i].vatRate??0 ) / 100 ))).toFixed(3);
                    // 待采购数: toPurQty
                    data[i].toPurQty = data[i].toPurQty && data[i].toPurQty < 0 ? 0 : data[i].toPurQty;
                }
            }
            return data ?? [];
        } finally {
        }
    }

    //查询生产合同排产明细
    const doQueryPP = async () => {
        try {
            // 查询合同明细
            let param = {pcId: pcId}
            const data = await Tools.runAsync(
                async () => {
                    return await Tools.http.post("/pur/purpcprodrow/listPurPcPpRowDRs", param)
                },
                {
                    error: {content: (err) => `查询失败: ${err.message}`},
                    loading: {show: false},
                    success: {show: false},
                }
            )
            return data ?? [];
        } finally {
        }
    }

    const printCss = {
        /*@media print {
                    body {zoom: 0.62}
                        .no-print{
                display:none;
            }
        }*/

        "@media print": {
            "body":{zoom: "0.62"}
            //"& .print-container": {
            //    overflow: "hidden"
            //},
            /*"& .order-edit-content":{
                display: "none"
            }*/
        },
        // 去除页眉页脚
        //"@page": {
        //    marginBottom: "0mm",
        //    marginTop: "0mm"
        //},
        /*display: "flex",
        flexDirection: "column",
        width: "1075px",
        margin: "auto",*/
        //height: "100vh",
        //overflow: "auto",
    }


    return (
        <div id={"printContent"} css={printCss} style={{height: '100%'}}>
            <div className={"print-content"}>
                <div className="order-edit-content" style={{width: "1075px"}}>
                    <table width="1075" className="print-table">
                        <thead>
                        <tr>
                            <td>
                                <div style={{paddingTop: "15px", fontWeight:"bold"}}>
                                    <div style={{textAlign: "center", fontSize: "28px"}}>{purPc.coNameEn}</div>
                                    <div style={{
                                        textAlign: "center",
                                        fontSize: "22px"
                                    }}>Contract of Processing with Supplied Materials</div>
                                </div>
                                <div style={{padding: "10px 0px", position: "relative", width: "1075px"}}>
                                    <div style={{position: "absolute", top: "-40px", left: "115px"}}>
                                        {purPc.pcQrcode && pcQrCode && <img
                                            title={purPc.pcQrcode}
                                            src={pcQrCode}
                                            height="130" width="130"/>}
                                    </div>
                                    <div className="r" style={{width: "320px"}}>
                                        <div>Contract number: {purPc.pcNo}</div>
                                        <div>Signing place: {purPc.coBizAddrEn}</div>
                                        <div>Signature date: {purPc.signDate}</div>
                                    </div>
                                    <div className="clear"></div>
                                </div>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        {/*<tr>
                            <td>
                                <div style={{padding: "10px 0px", fontSize: "16px"}}>
                                    <div className="l" style={{width: "360px"}}>
                                        款号：{purPc.styleNos}
                                    </div>
                                    <div className="l" style={{width: "360px"}}>
                                        订单号：{purPc.soNos}
                                    </div>
                                    <div className="l">
                                        订单流水号：DWP05XE2211001
                                    </div>
                                    <div className="clear"></div>
                                </div>
                            </td>
                        </tr>*/}
                        <tr>
                            <td>
                                <div style={{padding: "10px 0px", width: "1075px"}}>
                                    <div className="l" style={{fontWeight:"bold"}}>I.Object:</div>
                                    <div className="r" style={{width: "290px"}}>Currency:{purPc.currCode}</div>
                                    <div className="clear"></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>
                                    <table className="table-edit"
                                           style={{width: "1074px"}}>
                                        <thead>
                                            <tr>
                                                <th style={{width: "40px"}}>No.</th>
                                                <th style={{width: "90px"}}>Sumec Style</th>
                                                <th>Name of commodity</th>
                                                <th style={{width: "130px"}}>Remark</th>
                                                <th style={{width: "110px"}}>Quantity</th>
                                                <th style={{width: "50px"}}>Unit</th>
                                                <th style={{width: "80px"}}>Unit price</th>
                                                <th style={{width: "110px"}}>Amount</th>
                                                <th style={{width: "105px"}}>Delivery date</th>
                                                <th style={{width: "110px"}}>ETA-fabric& accessories</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {data?.map((item, index) => {
                                            return <tr>
                                                <td align="center">{index + 1}</td>
                                                <td>&nbsp; {item.styleInsideNo}</td>
                                                <td>&nbsp; 【{item.styleGoodsNameEn}】{item.goodsNameEn}</td>
                                                <td>&nbsp; {item.goodsSpecEn}</td>
                                                <td align="right">&nbsp;{item.purQty}</td>
                                                <td align="center">&nbsp;{item.uomName?.split("/")[1]}</td>
                                                <td align="right">&nbsp;{item.purTxPrice}</td>
                                                <td align="right">{item.purTxAmt}</td>
                                                <td align="center">&nbsp;{item.txDyDate}</td>
                                                <td align="center">&nbsp;{item.matDyDate}</td>
                                            </tr>
                                        })}
                                        <tr>
                                            <td align="center" colSpan={"3"}>Total</td>
                                            <td>&nbsp;</td>
                                            <td align="right">{pcSum?.purQty}</td>
                                            <td align="center">&nbsp;</td>
                                            <td align="right">&nbsp;</td>
                                            <td align="right">{pcSum?.purTxAmt}</td>
                                            <td align="center">&nbsp;</td>
                                            <td align="center">&nbsp;</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div style={{padding: "10px 0px"}}>
                                    <div className="l" style={{width: "1075px"}}></div>
                                    <div className="clear"></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td>
                                <div style={{width: "1075px"}}></div>
                            </td>
                        </tr>
                        <tr>
                            <div style={{width: "1075px"}}>
                                <td style={{wordBreak: "break-all"}}>
                                    <div style={{fontWeight:"bold"}}>II. Remark:</div>
                                    <div dangerouslySetInnerHTML={{__html: purPc?.pcMemo?.replaceAll("\n", "<br\>")}}/>
                                </td>
                            </div>
                        </tr>
                        <tr>
                            <div style={{width: "1075px"}}>
                                <td style={{wordBreak: "break-all"}}>
                                    <div style={{fontWeight:"bold"}}>III. Quality requirement:</div>
                                    <div
                                        dangerouslySetInnerHTML={{__html: purPc?.qcItemMemo?.replaceAll("\n", "<br\>")}}/>
                                </td>
                            </div>
                        </tr>
                        <tr>
                            <div style={{width: "1075px"}}>
                                <td style={{wordBreak: "break-all"}}>
                                    <div style={{fontWeight:"bold"}}>IV. Mode and conditions of payment:</div>
                                    <div
                                        dangerouslySetInnerHTML={{__html: purPc?.payItemText?.replaceAll("\n", "<br\>")}}/>
                                </td>
                            </div>
                        </tr>
                        <tr>
                            <div style={{width: "1075px"}}>
                                <td style={{wordBreak: "break-all"}}>
                                    <div style={{fontWeight:"bold"}}>V. The other clause:</div>
                                    <div dangerouslySetInnerHTML={{__html: purPc?.pcOther?.replaceAll("\n", "<br\>")}}/>
                                </td>
                            </div>
                        </tr>
                        <tr>
                            <td>
                                <div style={{padding: "10px 0px", width: "1075px"}}>
                                    <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                        <tr>
                                            <td width="100" style={{fontWeight:"bold"}}>The Demander</td>
                                            <td>&nbsp;</td>
                                            <td width="100" style={{fontWeight:"bold"}}>The Supplier</td>
                                            <td width="450">&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Company name (seal):</td>
                                            <td>&nbsp;{purPc.coNameEn}</td>
                                            <td>Company name (seal):</td>
                                            <td>&nbsp;{purPc.suppName}</td>
                                        </tr>
                                        <tr>
                                            <td>Address:</td>
                                            <td>&nbsp;{purPc.coBizAddrEn}</td>
                                            <td>Address:</td>
                                            <td>&nbsp;{purPc.suppCoRegAddr}</td>
                                        </tr>
                                        {/*<tr>
                                            <td>电话:</td>
                                            <td>&nbsp;{purPc.coRegPhone}</td>
                                            <td>电话:</td>
                                            <td>&nbsp;{purPc.suppPnrPhone}</td>
                                        </tr>*/}
                                        <tr>
                                            <td>Deposit bank:</td>
                                            <td>&nbsp;{purPc.coBankNameEn}</td>
                                            <td>Deposit bank:</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        {/*<tr>
                                            <td>帐号：</td>
                                            <td>&nbsp;{purPc.coBankAn}</td>
                                            <td>帐号:</td>
                                            <td>&nbsp;</td>
                                        </tr>*/}
                                        <tr>
                                            <td>SWIFT BIC:</td>
                                            <td>&nbsp;{purPc.coUscc}</td>
                                            <td>SWIFT BIC:</td>
                                            <td>&nbsp;{purPc.suppCoUscc}</td>
                                        </tr>
                                        {/*<tr>
                                            <td>委托代理人：</td>
                                            <td>&nbsp;</td>
                                            <td>委托代理人：</td>
                                            <td>&nbsp;</td>
                                        </tr>*/}
                                    </table>
                                    <div className="clear"></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div style={{float: "left",width:'537px'}} >
                                    {
                                        signList.map(sign=>{
                                            return <img
                                                src={sign?.signBase64} height="70"
                                                style={{margin: "5px"}}/>
                                        })
                                    }
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PURPRODPCPane;
